import { z } from 'zod';
/**
 * The fixed nutrient set stored as wide columns (docs/data-model.md).
 * Order matters only for display; membership is the contract.
 */
export const NUTRIENT_KEYS = [
    'energy_kcal',
    'energy_kj',
    'protein_g',
    'fat_g',
    'sat_fat_g',
    'mufa_g',
    'pufa_g',
    'trans_fat_g',
    'carb_g',
    'sugar_g',
    'starch_g',
    'fibre_g',
    'salt_g',
    'sodium_mg',
    'calcium_mg',
    'iron_mg',
    'potassium_mg',
    'magnesium_mg',
    'zinc_mg',
    'iodine_ug',
    'selenium_ug',
    'vit_a_ug',
    'vit_d_ug',
    'vit_e_mg',
    'vit_k_ug',
    'vit_c_mg',
    'thiamin_mg',
    'riboflavin_mg',
    'niacin_mg',
    'vit_b6_mg',
    'folate_ug',
    'vit_b12_ug',
];
/** The four macros plus energy, used for targets and plan validation. */
export const MACRO_KEYS = ['energy_kcal', 'protein_g', 'fat_g', 'carb_g', 'fibre_g'];
export const nutrientsSchema = z.object(Object.fromEntries(NUTRIENT_KEYS.map((k) => [k, z.number().nullable().optional()])));
export const foodSourceSchema = z.enum(['cofid', 'off', 'usda', 'user', 'manufacturer']);
//# sourceMappingURL=nutrients.js.map